import { mapActions } from 'vuex';
import { cookieGetters } from '@/helpers/cookieManager';
import SocialSignIn from '@/components/ui-elements/SocialSignIn';
import { INTEGRATED_SOCIAL_MEDIA_NAMES } from '@/helpers/social-auth-service';
import { getGoogleAuthLink, getSocialAuthLink } from '@/helpers/social-auth-service';
import { hasTrialInParams, isTrialEligible } from '~/views/auth/billing-utils';

export default {
  components: {
    'social-sign-in': SocialSignIn,
  },
  data() {
    return {
      INTEGRATED_SOCIAL_MEDIA_NAMES,

      error: this.$route.query.error_message,
      provider: this.$route.query.provider,
      code: this.$route.query.code,
      redirect_uri: this.$route.query.redirect_uri,
      socialLoading: false,
      sub: true,
    };
  },
  async created() {
    // some kind of prototype inheritance and updating top component property or something?
    this.googleAuthLink = getGoogleAuthLink(this.service);

    window.addEventListener('message', this.handleOauthEvent);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleOauthEvent);
  },
  methods: {
    ...mapActions(['socialSignIn']),
    async handleOauthEvent(event) {
      if (event.origin !== window.location.origin || event.data.type !== 'OAUTH_RESULT') {
        return;
      }

      const { provider, code, error, redirect_uri } = event.data;

      this.error = error;
      this.code = code;
      this.redirect_uri = redirect_uri;
      this.provider = provider;

      try {
        const trial = isTrialEligible(this.currentPackage) && hasTrialInParams(this.$route.query);
        const trial_period = trial
          ? this.$route.query['trial-period'] || this.$route.query.trial_period || 'default'
          : undefined;

        this.socialLoading = true;
        await this.$recaptchaLoaded();
        this.recaptcha = await this.$recaptcha('social_sign_in');
        const newsletterSubscription = window.sessionStorage.getItem('newsletterSubscription') !== '0';
        window.sessionStorage.removeItem('newsletterSubscription');

        const data = {
          code: this.code,
          redirect_uri: this.redirect_uri,
          plan_id: this.currentPackage?.package_identity || process.env.FREE_PLAN_ID,
          billing_cycle: this.billingCycle,
          trial,
          trial_period,
          ['trial-period']: trial_period,
          recaptcha: this.recaptcha,
          ga_client_id: cookieGetters.getGaClientId(),
          mixpanel_id: cookieGetters.getMixpanelId(),
          first_visit_date: cookieGetters.getFirstVisitDate(),
          ...cookieGetters.getUtmAndMarketingParameters(),
          referral: window.Rewardful?.referral ?? null,
          newsletter_subscription: newsletterSubscription,
          quantity: this.quantity,
        };

        this.error = await this.socialSignIn({
          provider: this.provider,
          data,
          trial,
          trial_period,
          ['trial-period']: trial_period,
        });
      } catch (error) {
        if (this.mixinResource === 'sign-up') {
          this.trackSignupFailedEvent(this.provider ?? 'other', error);
        }
      } finally {
        this.socialLoading = false;
      }

      if (this.error) {
        let msg = this.error?.response?.data?.errors[0]?.title ?? this.error?.[0]?.detail ?? this.error;
        this.$toastr.e(msg);

        if (this.mixinResource === 'sign-up') {
          this.trackSignupFailedEvent(this.provider ?? 'other', msg);
        }
      }
    },
    openSocialSignIn(social) {
      this.sub = false;
      const socialAuthLink = getSocialAuthLink(social);

      if (this.mixinResource === 'sign-up') {
        this.trackSignupStartEvent(social, this.username);
      }

      if (socialAuthLink) {
        this.locateTo(socialAuthLink);
      }
    },
    locateTo(link) {
      let h = 700;
      let w = 500;
      let t = screen.height / 2 - h / 2;
      let l = screen.width / 2 - w / 2;

      window.open(
        link,
        '_blank',
        `toolbar=0,location=0,menubar=0,left=${l},top=${t},height=${h},width=${w},alwaysRaised=yes`,
      );
    },
  },
};
